export const validateUsername = (userName) => {
  const trimmedUserName = userName?.trim() ?? "";
  
  if (!trimmedUserName) return false;

  const isValid = 
      /^[a-zA-Z]/.test(trimmedUserName) &&
      (trimmedUserName.match(/[a-zA-Z]/g) || []).length >= 3 &&
      /^[a-zA-Z0-9_.\-]+$/.test(trimmedUserName);
      
  return isValid;
};
